import React from 'react';
import { cn } from '../../lib/utils';

interface RecruiterPageShellProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  /** Wider canvas (e.g. Pipeline kanban). Default: max-w-7xl */
  wide?: boolean;
  /** Skip inner max-width container — child owns layout (e.g. Inbox split view). */
  fullBleed?: boolean;
  /** Skip vertical padding on the content container. */
  noPadding?: boolean;
}

/**
 * Shared B2B recruiter page canvas — flat slate-50 base, consistent content gutter.
 */
export function RecruiterPageShell({
  children,
  className,
  contentClassName,
  wide,
  fullBleed,
  noPadding,
}: RecruiterPageShellProps) {
  return (
    <div className={cn('relative min-h-screen overflow-hidden bg-slate-50', className)}>
      {fullBleed ? (
        <div className={cn('relative', contentClassName)}>{children}</div>
      ) : (
        <div
          className={cn(
            'relative mx-auto px-4 sm:px-6',
            !noPadding && 'py-6 lg:py-8',
            wide ? 'max-w-[1600px]' : 'max-w-7xl',
            contentClassName,
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
}
